//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    created: function created() {
        if (process.client) {
            //localStorage.setItem('aggregatePageVisited', 1);
            customLocalStorage.setItem('aggregatePageVisited', 1);
        }
    },

    computed: {
        lang: function lang() {
            return this.$root._route.params.lang;
        },
        websiteName: function websiteName() {
            var displayName = global.websiteSettings.extra_info.display_name;
            if (displayName) {
                return this.$root.trans('st_public.' + displayName);
            }
            return '';
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/aggregate-results.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/aggregate-results.vue
// module chunks = 50